<template>
  <div
    class="modal fade"
    tabindex="-1"
    ref="dialogModal"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog" :class="size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5">{{ modalTitle }}</h5>
          <button
            type="button"
            class="close btn btn-secondary"
            aria-label="Close"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <form
          class="needs-validation"
          data-toggle="validator"
          @submit.prevent="handleSubmit"
          ref="basicForm"
        >
          <div class="modal-body mh-100 position-relative" :style="[bodyStyle]">
            <div v-if="currentItem">
              <div class="row mb-3">
                <div class="col-md-6 form-group row align-items-center my-2">
                  <label
                    class="form-label col-md-3 col-form-label"
                    @click="clickTest"
                    >編號</label
                  >
                  <div class="col-md-9">
                    <input
                      class="form-control"
                      v-model="currentItem.eventNumber"
                      required
                      disabled
                    />
                  </div>
                </div>
                <div class="col-md-6 form-group row align-items-center my-2">
                  <label class="form-label col-md-3 col-form-label"
                    >車牌號碼</label
                  >
                  <div class="col-md-9">
                    <input
                      class="form-control"
                      v-model="currentItem.licensePlate"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6 form-group row align-items-center my-2">
                  <label class="col-md-3 col-form-label">舉發時間</label>
                  <div class="col-md-9">
                    <input
                      class="form-control"
                      v-model="currentItem.dt"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6 form-group row align-items-center my-2">
                  <label class="col-md-3 col-form-label">舉發地點</label>
                  <div class="col-md-9">
                    <input
                      class="form-control"
                      v-model="currentItem.publicPlaceName"
                      required
                    />
                  </div>
                </div>
              </div>

              <!-- todo： add image with watermark -->
              <div class="mb-3 text-center w-50">
                <canvas ref="canvas2" class="img-fluid"></canvas>
                <!-- <img
                  alt="violation-image"
                  src="../../assets/img/test.jpg"
                  class="img-fluid"
                /> -->
              </div>

              <div class="mb-3">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  一、您停車不當已造成下列規定：
                </p>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.checkgroup1.checkbox1"
                  />
                  <label class="form-check-label"
                    >在禁止汽機車進入之地區，違規進入並停車者。</label
                  >
                </div>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.checkgroup1.checkbox2"
                  />
                  <label class="form-check-label"
                    >在殘障通道或行人通道區，違規停車者。</label
                  >
                </div>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.checkgroup1.checkbox3"
                  />
                  <label class="form-check-label"
                    >不依車輛種類違規停車或顯有妨礙他車通行者。</label
                  >
                </div>
              </div>

              <div class="mb-3">
                <p
                  class="fw-bold alert alert-success align-items-center my-2 fs-6"
                  role="alert"
                >
                  二、您已違反發展觀光條例第64條第1款規定，本處己錄案並開立違規事件通知單予台端：
                </p>
                <div class="form-check my-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="currentItem.checkgroup2.checkbox1"
                  />
                  <label class="form-check-label"
                    >若再次於禁止進入之地區停車，得由目的事業主管機關處新臺幣五千元以上十萬元以下罰鍰。</label
                  >
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input my-2"
                    type="checkbox"
                    v-model="currentItem.checkgroup2.checkbox2"
                  />
                  <label class="form-check-label"
                    >依發展觀光條例第65條規定：所處之罰鍰，經通知限期繳納，屆期未繳納者，將依法移送強制執行。</label
                  >
                </div>
              </div>
            </div>

            <!-- </transition> -->
          </div>

          <div class="modal-footer d-flex justify-content-center">
            <!-- <div class="modal-footer justify-content-between"> -->

            <div
              v-if="isMutiple"
              class="d-flex justify-content-between align-items-center footer-controls"
            >
              <button
                type="button"
                class="btn btn-primary same-width"
                @click="prevPage"
                :disabled="currentPage === 1"
              >
                上一頁
              </button>
              <span class="mx-3">{{ currentPage }} / {{ allPage }}</span>
              <button
                type="submit"
                class="btn same-width"
                :class="currentPage === allPage ? 'btn-warning' : 'btn-primary'"
              >
                {{ currentPage === allPage ? "確認輸出PDF" : "下一頁" }}
              </button>
            </div>
            <div v-if="!isMutiple">
              <button type="submit" class="btn btn-primary">確認</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import { my } from "resource";

import {
  printBasicViolationNotice,
  printOfficialViolationNotice,
} from "@/utils/exportViolationPDF";
import {
  getSerialNumber,
  addSerialNumber,
} from "../../api/eastCoastDataApi/ElkQuery/VehicleElk";

export default {
  data() {
    return {
      isActive: true,
      bodyStyle: "",
      isMutiple: true,
      allPage: 0,
      currentPage: 1,
      form: [],
      loading: false,
      postSerialNumber:[],
      accountName: "",
    };
  },
  props: ["modalTitle", "mode", "modalSize", "violationData"],
  name: "dialog-modal",
  computed: {
    size() {
      return `modal-${this.modalSize}`;
    },
    currentItemIndex() {
      return this.currentPage - 1;
    },
    currentItem() {
      return this.form[this.currentItemIndex];
    },
  },

  methods: {
    openModal() {
      $(this.$refs.dialogModal).modal("show");
    },
    closeModal() {
      $(this.$refs.dialogModal).modal("hide");
    },
    nextPage() {
      if (this.currentPage < this.allPage) {
        this.currentPage++;
      } else {
        this.getExportViolationPDF();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    async getExportViolationPDF() {
      try {
        await printBasicViolationNotice(this.form);
        // 成功列印後送出流水號記錄 & emit selectedItems
        this.addSerialNumber(this.postSerialNumber);
        this.$emit("clearSelectedItems");
        this.closeModal();
        // console.log("initSelectedItems");
      } catch (error) {
        console.error("printBasicViolationNotice", error);
      }
    },

    async initFormData(data) {
      //將傳入的 data 物件陣列，轉換為 form 的初始值
      let serialNumber = await this.getSerialNumber(data);
      this.postSerialNumber = [];
      console.log("maxSerialNumber", serialNumber);
      this.form = []; // 先清空表單陣列
      let currentSerial = serialNumber; // 設定當前的序號為傳入的序號
      data.forEach((item) => {
        if(item.serialNumber === null || item.serialNumber === undefined){
          currentSerial += 1;
          this.postSerialNumber.push({
              eventId: item.eventID,
              serialNumber: currentSerial,
              printAccountName: this.accountName, 
              printTime: moment().format(), 
            });
          }else{
            currentSerial = item.serialNumber; // 如果已有流水號，則使用該號碼
          }
       
        console.log("currentSerial",currentSerial)
        const formItem = {
          eventNumber: `${Utils.convertToTaiwanYear(item.dt)}${moment(
            item.dt
          ).format("MM")}${Utils.formatThreeDigits(currentSerial)}`,
          serialNumber: currentSerial,
          licensePlate: item.licensePlate,
          area: item.areaName,
          imgUrl: this.getElkImgUrl(item),
          imgData: null,
          dt: `${Utils.convertToTaiwanYear(item.dt)}${moment(item.dt).format(
            "-MM-DD HH:mm"
          )}`,
          publicPlaceName: item.publicPlaceName,
          checkgroup1: {
            checkbox1: false,
            checkbox2: false,
            checkbox3: false,
          },
          checkgroup2: {
            checkbox1: false,
            checkbox2: false,
          },
        };

        this.form.push(formItem);
      });
      console.log("this.form", this.form);
      console.log("postSerialNumber", this.postSerialNumber);
    },
    getElkImgUrl(item) {
      return Utils.transElkImgByNginx(item.streamUrl);
    },

    async getSerialNumber(data) {
      let condition = {
        year: moment(data[0].dt).format("YYYY"),
        month: moment(data[0].dt).format("MM"),
      };
      let response = await getSerialNumber(condition);

      return response.data.count;
    },

    clickTest() {
      console.log("this.canvas", this.$refs.canvas2);
    },

    addWatermark(item) {
      // console.log("item", item);
      // const img = new Image();
      // img.crossOrigin="anonymous"
      // img.src = this.getElkImgUrl(item);
      // await img.decode();
      // const canvas = this.$refs.canvas;

      const canvas = this.$refs.canvas2;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.crossOrigin = "anonymous";

      // img.src = require("@/assets/img/test.jpg");
      img.src = item.imgUrl;

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        ctx.font = "22px Arial";
        ctx.fillStyle = "rgba(255, 255, 255, 1)";
        const text = `${item.area}_${item.publicPlaceName}`;

        const textHeight = parseInt(ctx.font, 20);
        ctx.fillText(text, 15, textHeight + 20);

        this.currentItem.imgData = canvas.toDataURL("image/png");
      };

      img.onerror = (err) => {
        console.error("圖片加載失敗", err);
      };
    },

    async addSerialNumber(data){
      console.log("addSerialNumber", data);
      if(data.length !== 0){
        console.log("data.length !== 0")
        await addSerialNumber(data);
   
      }

    },
    handleSubmit() {
      // required 項目全數填寫完才能送出
      if (this.currentPage !== this.allPage) {
        this.nextPage();
      } else {
        const form = this.$refs.basicForm;
        if (form.checkValidity()) {
          this.getExportViolationPDF();
 
        }
      }
    },
  },
  watch: {
    violationData: {
      handler(newVal) {
        console.log("newVal", newVal);
        if (newVal === null || newVal.length === 0) {
          return;
        }
        this.allPage = newVal.length;
        this.isMutiple = this.allPage > 1;
        this.initFormData(newVal);
      },
    },

    currentItem: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.addWatermark(newVal); // 確定已渲染完成後再添加水印
          });
          // this.addWatermark(newVal);
        }
      },
    },
  },
  async mounted() {
    $(this.$refs.dialogModal).on("shown.bs.modal", () => {
      this.$emit("dialog-opend");
    });
    $(this.$refs.dialogModal).on("hidden.bs.modal", () => {
      this.$emit("dialog-close");
    });

    my.info().then(a => {
      this.accountName = a.body.name;
    });
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.footer-controls {
  /* width: 100%; */
  max-width: 400px;
}

.same-width {
  /* width: 100%; */
  min-width: 100px;
}

.form-label,
.col-form-label,
.form-check-label,
input.form-control {
  font-size: 1rem; /* 或根據需要設為 1.1rem、1.2rem 等 */
}

/* 自訂 checkbox 大小與對齊方式 */
.form-check-input {
  width: 1.2em;
  height: 1.2em;
  margin-top: 0.25em;
  vertical-align: middle;
}

/* 統一 checkbox 與 label 的間距與對齊 */
.form-check {
  display: flex;
  align-items: center;
  gap: 0.4em;
  font-size: 1rem;
}

/* optional: 增加行距讓表單整體更舒服 */
.form-group {
  line-height: 1.6;
}

label {
  font-weight: 400;
}
</style>
